import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { list, reset } from '../../actions/song/picked';
import { success } from '../../actions/song/delete';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

class Picked extends Component {
    static propTypes = {
        error: PropTypes.string,
        loading: PropTypes.bool.isRequired,
        data: PropTypes.object.isRequired,
        list: PropTypes.func.isRequired,
        reset: PropTypes.func.isRequired
    };

    componentDidMount() {
        this.props.list();
    }

    componentWillUnmount() {
        this.props.reset();
    }

    render() {
        const songs = this.props.data['hydra:member'];

        return (
            <div>
                {songs &&
                    songs.length > 0 && (
                        <div>
                            <h2>Upcoming Songs</h2>

                            {this.props.error && (
                                <div className="alert alert-danger">
                                    {this.props.error}
                                </div>
                            )}

                            <List>
                                {songs.map(song => (
                                    <ListItem key={song['@id']} button>
                                        <ListItemText primary={song['title']} />
                                    </ListItem>
                                ))}
                            </List>
                        </div>
                    )}

                {this.props.loading && (
                    <div className="alert alert-info">Loading...</div>
                )}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        data: state.song.picked.data,
        error: state.song.picked.error,
        loading: state.song.picked.loading,
        picked: state.song.picked.picked
    };
};

const mapDispatchToProps = dispatch => {
    return {
        list: page => dispatch(list(page)),
        reset: () => {
            dispatch(reset());
            dispatch(success(null));
        }
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Picked);



// WEBPACK FOOTER //
// ./src/components/song/Picked.js